/*
 * Copyright (c) 2021, salesforce.com, inc.
 * All rights reserved.
 * SPDX-License-Identifier: BSD-3-Clause
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/BSD-3-Clause
 */
const mdSize = {height: 11, h: 11, borderRadius: 'base'}
import InputStyles from './input';

export default {
    sizes: {
        md: {
            field: mdSize
        }
    },
    variants: {
        outline: {
            field: {
                ...InputStyles.variants.outline.field,
                borderColor: 'gray.800',
                _disabled: {
                    opacity: 1,
                    color: 'gray.700',
                    background: 'gray.450'
                },
                _placeholder: {
                    color: 'gray.700'
                }
            }
        }
    }
}
